import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid2,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import { getDobAgeSelecterData } from "../../../utilities/data";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import NumericPadInput from "../../../components/NumericPadInput";
import { useEffect, useState } from "react";
import {
  notifyError,
  notifySuccess,
  splitFieldsByPageBreak,
} from "../../../utilities/helper";
import { useNavigate } from "react-router-dom";
import { saveSubjectDataService } from "../../../services/subjectService";
import SubjectConfirmation from "./SubjectConfirmation";
import dayjs from "dayjs";
import FieldRenderer from "./FileRenderer";

export const DynamicForm = ({
  fieldJsonList,
  allQuestionsData,
  setLoad,
  showConfirm,
  setShowConfirm,
  responseData,
  setResponseData,
  pageName,
  languageData,
  setLanguageData,
}) => {
  const access_token = localStorage.getItem("access_token");

  const roleId = localStorage.getItem("roleId");

  const [preview, setPreview] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [payloadData, setPayloadData] = useState(allQuestionsData);
  const [selectedLanguage, setSelectedLanguage] = useState("");

  const pages = splitFieldsByPageBreak(
    fieldJsonList.map(normalizeField).filter(Boolean)
  );
  // const currentFields = pages[currentPageIndex];
  const visiblePages = pages.slice(0, currentPageIndex + 1);

  // Add forceDisabled flag to fields from previous pages
  const currentFields = visiblePages.flatMap((page, pageIndex) =>
    page.map((field) => ({
      ...field,
      forceDisabled: pageIndex < currentPageIndex,
    }))
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (responseData) {
      setShowConfirm(true);
    }
  }, [responseData]);

  function normalizeField(jsonString) {
    try {
      const field = JSON.parse(jsonString);
      return {
        id: field.id || field.fieldId,
        type: field.key || field?.element,
        name: field.name || field.field_name,
        label: field.props?.label || field.text || field.name,
        props: field.props || {},
        specialProps:
          {
            isBold: field?.bold,
            isItalic: field?.italic,
            content: field?.content,
          } || {},
        required: field.required || false,
        options: field?.pageTitle?.split(",") || [],
        answer_id: field?.answer_id,
        dependsOn: field?.dependsOn || null,
        hasCondition: field?.hasCondition || false,
        hasValue: field?.hasValue || null,
        doRule: field?.doRule || null,
      };
    } catch (e) {
      console.error("Invalid JSON:", e);
      return null;
    }
  }
  const buildValidationSchema = (fields) => {
    const shape = {};

    fields?.forEach((field) => {
      if (!field.name) return;

      const uniqueName = `${field.name}_${field?.answer_id}`;
      let rule = yup.string();

      if (
        field.type === "DatePicker" ||
        // field?.type == "VisitDatePicker" ||
        field?.type == "Date"
      ) {
        rule = yup
          .mixed()
          .nullable()
          .test("is-valid-date", "Date is required", (value) => {
            if (value === null || value === undefined || value === "")
              return true;
            return dayjs(value).isValid();
          });
      } else if (field?.type === "VisitDatePicker")
        rule = yup.string().nullable();
      else if (field.type === "TimePicker" || field?.type === "Time")
        rule = yup.string().nullable();
      else if (field?.type === "AgeRange") {
        rule = yup.object().shape({
          start: yup.string(),
          end: yup
            .string()
            .test(
              "is-after-start",
              "End date must be on or after start date",
              function (endDate) {
                const { start } = this.parent;
                if (!start || !endDate) return true; // skip validation if one is missing
                return new Date(endDate) >= new Date(start);
              }
            ),
        });
      } else if (field?.type == "Camera") {
        rule = yup
          .mixed()
          .test("isFile", "Invalid file", (value) => {
            // Allow null, undefined, or a valid File
            return value == null || value instanceof File;
          })
          .nullable();
      }
      if (field.required)
        rule = rule.required(`${field.label || field.name} is required`);

      shape[uniqueName] = rule;
    });

    // This is for non-empty fields allowed
    // fields?.forEach((field) => {
    //   if (!field.name) return;

    //   const uniqueName = `${field.name}_${field?.answer_id}`;
    //   let rule = yup.string();

    //   // ❗ Add this test to avoid whitespace-only values
    //   if (
    //     field.type !== "DatePicker" &&
    //     field.type !== "Date" &&
    //     field.type !== "VisitDatePicker" &&
    //     field.type !== "TimePicker" &&
    //     field.type !== "Time" &&
    //     field.type !== "AgeRange" &&
    //     field.type !== "Camera"
    //   ) {
    //     rule = rule.test(
    //       "not-empty",
    //       `${field.label || field.name} cannot be empty or spaces`,
    //       (value) => {
    //         if (value == null) return true;
    //         return String(value).trim().length > 0;
    //       }
    //     );
    //   }

    //   if (field.type === "DatePicker" || field.type === "Date") {
    //     rule = yup
    //       .mixed()
    //       .nullable()
    //       .test("is-valid-date", "Date is required", (value) => {
    //         if (value === null || value === undefined || value === "")
    //           return true;
    //         return dayjs(value).isValid();
    //       });
    //   } else if (field.type === "VisitDatePicker") {
    //     rule = yup.string().nullable();
    //   } else if (field.type === "TimePicker" || field.type === "Time") {
    //     rule = yup.string().nullable();
    //   } else if (field.type === "AgeRange") {
    //     rule = yup.object().shape({
    //       start: yup.string(),
    //       end: yup
    //         .string()
    //         .test(
    //           "is-after-start",
    //           "End date must be on or after start date",
    //           function (endDate) {
    //             const { start } = this.parent;
    //             if (!start || !endDate) return true;
    //             return new Date(endDate) >= new Date(start);
    //           }
    //         ),
    //     });
    //   } else if (field.type === "Camera") {
    //     rule = yup
    //       .mixed()
    //       .test("isFile", "Invalid file", (value) => {
    //         return value == null || value instanceof File;
    //       })
    //       .nullable();
    //   }

    //   if (field.required) {
    //     rule = rule.required(`${field.label || field.name} is required`);
    //   }

    //   shape[uniqueName] = rule;
    // });

    return yup.object().shape(shape);
  };

  // const fields = fieldJsonList.map(normalizeField).filter(Boolean);

  const schema = buildValidationSchema(currentFields);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    defaultValues: {
      dobAge: "",
    },
  });

  const componentMap = {
    TextArea: ({ label, register, name, isRequired, disabled }) => {
      return (
        <div>
          {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
          <TextareaAutosize
            minRows={3}
            className="form-text-area"
            disabled={disabled}
            fullWidth
            type="text"
            {...register(name)}
          />
        </div>
      );
    },

    DobAge: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Select
              size="small"
              fullWidth
              displayEmpty
              disabled={disabled}
              value={field.value || ""} // Ensure controlled
              onChange={(e) => {
                field.onChange(e.target.value);
              }} // Bind change
              inputRef={field.ref} // Ref support
              onBlur={field.onBlur} // Validation on blur
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {(getDobAgeSelecterData() || []).map((item, index) => (
                <MenuItem key={index} value={item?.key}>
                  {item?.value}
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </div>
    ),

    AgeRange: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}

        <div style={{ display: "flex", gap: "10px" }}>
          <Controller
            name={`${name}.start`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                size="small"
                type="date"
                disabled={disabled}
                fullWidth
                label="Start Date"
                InputLabelProps={{ shrink: true }}
                {...field}
              />
            )}
          />

          <Controller
            name={`${name}.end`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                size="small"
                type="date"
                fullWidth
                disabled={disabled}
                label="End Date"
                InputLabelProps={{ shrink: true }}
                {...field}
              />
            )}
          />
        </div>
      </div>
    ),

    TimePicker: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <input type="time" {...register(name)} disabled={disabled} />
      </div>
    ),

    AgeRangeYear: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          size="small"
          fullWidth
          type="text"
          disabled={disabled}
          inputProps={{
            maxLength: 4,
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
          {...register(name, {
            required: `${label || name} is required`,
            validate: (value) => {
              if (!/^\d{1,4}$/.test(value))
                return "Only 1-4 digit whole numbers allowed";
              if (parseInt(value, 10) < 0) return "Negative values not allowed";
              return true;
            },
            onChange: (e) => {
              const raw = e.target.value;
              // Remove non-digit characters
              const digitsOnly = raw.replace(/\D/g, "").slice(0, 4);
              e.target.value = digitsOnly;
            },
          })}
        />
      </div>
    ),

    CheckBox: ({ label, name, register, isRequired, disabled }) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "revert",
          gap: "8px",
          margin: "8px 0",
        }}
      >
        <FormControlLabel
          control={<Checkbox {...register(name)} />}
          label={label}
          disabled={disabled}
        />
      </div>
    ),

    Date: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <DatePicker
                sx={{ width: "100%" }}
                disabled={disabled}
                format="DD-MMM-YYYY"
                // FIX 1: Convert stored string → dayjs object for UI
                value={field.value ? dayjs(field.value, "YYYY-MM-DD") : null}
                // FIX 2: Store only clean date string → no timezone shift
                onChange={(date) => {
                  const formatted = date ? date.format("YYYY-MM-DD") : null;
                  field.onChange(formatted);
                }}
              />
            )}
          />
        </LocalizationProvider>
      </div>
    ),

    EQ5D5L: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <DatePicker
                value={field.value}
                sx={{ width: "100%" }}
                disabled={disabled}
                format="DD-MMM-YYYY"
                onChange={(date) => field.onChange(date)}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            )}
          />
        </LocalizationProvider>
      </div>
    ),

    MultiSelectCheckBox: ({ label, name, options, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <FormControl size="small" fullWidth>
          <Controller
            name={name}
            control={control}
            defaultValue={[]}
            render={({ field }) => (
              <Select
                {...field}
                multiple
                disabled={disabled}
                displayEmpty
                renderValue={(selected) =>
                  selected.length > 0 ? selected.join(", ") : "Select"
                }
              >
                {(options || []).map((option, index) => (
                  <MenuItem key={index} value={option}>
                    <Checkbox checked={field.value.includes(option)} />
                    <ListItemText primary={option} />
                  </MenuItem>
                ))}
              </Select>
            )}
          />
        </FormControl>
      </div>
    ),

    Time: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => {
              const timeValue =
                typeof field.value === "string"
                  ? dayjs(field.value, "hh:mm A") // Parse as 12-hour format
                  : field.value;

              return (
                <TimePicker
                  ampm // enables AM/PM mode
                  sx={{ width: "100%" }}
                  value={timeValue}
                  disabled={disabled}
                  onChange={(time) => {
                    if (time && dayjs(time).isValid()) {
                      field.onChange(time.format("hh:mm A")); // Save in AM/PM format
                    } else {
                      field.onChange(null);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} size="small" fullWidth />
                  )}
                />
              );
            }}
          />
        </LocalizationProvider>
      </div>
    ),

    DropDown: ({ label, name, register, options, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Select
              size="small"
              fullWidth
              disabled={disabled}
              displayEmpty
              value={field.value || ""} // Ensure controlled
              onChange={(e) => {
                field.onChange(e.target.value);
              }} // Bind change
              inputRef={field.ref} // Ref support
              onBlur={field.onBlur} // Validation on blur
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {(options || []).map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </div>
    ),

    DispenseDrugKit: ({
      label,
      name,
      register,
      options,
      isRequired,
      disabled,
    }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Select
              size="small"
              fullWidth
              displayEmpty
              disabled={disabled}
              value={field.value || ""} // Ensure controlled
              onChange={(e) => {
                field.onChange(e.target.value);
              }} // Bind change
              inputRef={field.ref} // Ref support
              onBlur={field.onBlur} // Validation on blur
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {(options || []).map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </div>
    ),

    NumericPad: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          defaultValue=""
          render={({ field }) => (
            <NumericPadInput
              label={label}
              disabled={disabled}
              name={name}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </div>
    ),

    RadioButton: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          defaultValue={false}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Radio
                  checked={field.value === true}
                  disabled={disabled}
                  onChange={(e) => field.onChange(e.target.checked)}
                />
              }
              label={label}
            />
          )}
        />
      </div>
    ),

    RadioButtonGroup: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          defaultValue=""
          render={({ field }) => (
            <RadioGroup {...field} row>
              {["male", "female", "other"].map((option) => (
                <FormControlLabel
                  key={option}
                  value={option}
                  disabled={disabled}
                  control={<Radio />}
                  label={option.charAt(0).toUpperCase() + option.slice(1)}
                />
              ))}
            </RadioGroup>
          )}
        />
      </div>
    ),

    TimeTwo: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <TimePicker
                sx={{
                  width: "100%",
                }}
                value={field.value}
                disabled={disabled}
                onChange={(time) => field.onChange(time)}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            )}
          />
        </LocalizationProvider>
      </div>
    ),

    Camera: ({ label, name, control, isRequired, disabled }) => {
      return (
        <div>
          {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}

          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <>
                <input
                  accept="image/*"
                  type="file"
                  capture="environment"
                  style={{ display: "none" }}
                  disabled={disabled}
                  id={`camera-input-${name}`}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setPreview(URL.createObjectURL(file));
                      field.onChange(file);
                    }
                  }}
                />
                <label htmlFor={`camera-input-${name}`}>
                  <Button variant="outlined" component="span">
                    Upload / Capture Image
                  </Button>
                </label>

                {preview && (
                  <Box mt={2}>
                    <img
                      src={preview}
                      alt="preview"
                      style={{
                        width: "70%",
                        maxHeight: 600,
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                )}
              </>
            )}
          />
        </div>
      );
    },

    HotSpot: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    None: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    VisitDatePicker: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <DatePicker
                value={field.value}
                sx={{ width: "100%" }}
                disabled={disabled}
                format="DD-MMM-YYYY"
                onChange={(date) => {
                  const formatted = date
                    ? dayjs(date).format("YYYY-MM-DD")
                    : null;
                  field.onChange(formatted);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            )}
          />
        </LocalizationProvider> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <DatePicker
                sx={{ width: "100%" }}
                disabled={disabled}
                format="DD-MMM-YYYY"
                // FIX 1: Convert stored string → dayjs object for UI
                value={field.value ? dayjs(field.value, "YYYY-MM-DD") : null}
                // FIX 2: Store only clean date string → no timezone shift
                onChange={(date) => {
                  const formatted = date ? date.format("YYYY-MM-DD") : null;
                  field.onChange(formatted);
                }}
              />
            )}
          />
        </LocalizationProvider>
      </div>
    ),

    SingleSelectCheckbox: ({
      label,
      name,
      control,
      options,
      isRequired,
      disabled,
    }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}

        <Controller
          name={name}
          control={control}
          defaultValue=""
          render={({ field }) => (
            <Select
              {...field}
              fullWidth
              size="small"
              displayEmpty
              disabled={disabled}
              renderValue={(selected) => {
                const selectedOption = (options || []).find(
                  (opt) => opt === selected
                );
                return selectedOption ? selectedOption : "Select";
              }}
            >
              {(options || []).map((option) => (
                <MenuItem key={option} value={option}>
                  <Checkbox
                    checked={field?.value === option}
                    sx={{ paddingRight: 1 }}
                  />
                  <ListItemText primary={option} />
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </div>
    ),

    NRS: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    VideoPlayer: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    PatientVisit: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    VAS: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    Header: ({ label, name, isRequired, specialProps }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <h2
          style={{
            fontStyle: `${specialProps?.isItalic ? "italic" : ""}`,
            fontWeight: `${specialProps?.isBold ? "bold" : ""}`,
          }}
        >
          {specialProps?.content || name}
        </h2>
      </div>
    ),

    Paragraph: ({ label, name, isRequired, specialProps }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <p
          style={{
            fontStyle: `${specialProps?.isItalic ? "italic" : ""}`,
            fontWeight: `${specialProps?.isBold ? "bold" : ""}`,
          }}
        >
          {specialProps?.content || name}
        </p>
      </div>
    ),
  };

  const onSubmit = async (data, e) => {
    e.preventDefault();

    for (const item of payloadData?.patientVisitData?.questionnaire
      ?.questions || []) {
      let answers = item?.answers?.[0];
      if (!answers) continue;

      for (const key in data) {
        if (!data.hasOwnProperty(key)) continue;

        let value = data[key];
        const changedAnswerId = key?.split("_")[1];
        if (changedAnswerId !== answers?.questionId) continue;

        // 🔍 Handle Camera (File) input
        if (value instanceof File) {
          try {
            const base64 = await convertToBase64(value);
            answers.freeTextAnswer = base64;
            answers.value = base64;
          } catch (error) {
            console.error("Error converting image to base64:", error);
          }
        } else if (value instanceof Object && value?.start && value?.end) {
          answers.freeTextAnswer = JSON.stringify(value);
          answers.value = JSON.stringify(value);
        } else {
          if (value instanceof Object) {
            answers.freeTextAnswer = "";
            answers.value = "";
          } else {
            console.log("Value1027", value);
            answers.freeTextAnswer = value;
            answers.value = value;
          }
        }
      }
    }

    try {
      setLoad(true);
      payloadData.patientVisitData.questionnaire.dosageChangeNeeded = "false";
      const res = await saveSubjectDataService(
        access_token,
        payloadData?.patientVisitData?.questionnaire,
        roleId,
        selectedLanguage
      );
      if (
        res?.data?.status == 200 &&
        res?.data?.result?.patientVisitData?.questionnaire
      ) {
        const updatedData = res?.data?.result?.patientVisitData?.questionnaire;
        const languageData = res?.data?.result?.language;
        setResponseData({ ...updatedData });
        setLanguageData(languageData);
        setLoad(false);
        notifySuccess("Subject Created Successfully");
      }
    } catch (err) {
      setLoad(false);
      console.log("Error", err);
      const errorData = err?.response?.data?.errors;
      const extractedErrors = [];

      for (const key in errorData) {
        if (errorData.hasOwnProperty(key)) {
          const messages = errorData[key];
          const match = key.match(/\[(\d+)\]/);
          if (match && messages.length > 0) {
            const quesNo = parseInt(match[1], 10);
            const message = messages[0]; // first message only
            extractedErrors.push({ quesNo, message });
          }
        }
      }
      const fields = fieldJsonList.map(normalizeField).filter(Boolean);
      if (extractedErrors.length > 0) {
        notifyError(
          fields[extractedErrors[0].quesNo]?.name +
            " " +
            extractedErrors[0].message
        );
      }
      if (err?.status == 404) {
        navigate("/unAuthorize");
      }
    }
  };

  const convertToBase64 = (file) =>
    new Promise((resolve, reject) => {
      if (!(file instanceof Blob)) {
        reject("Not a valid File or Blob");
      }
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });

  return showConfirm && responseData ? (
    <SubjectConfirmation
      data={responseData}
      pageName={pageName}
      languageData={languageData}
    />
  ) : (
    <Box
      component="form"
      autoComplete="off"
      sx={{ height: "auto", width: "100%" }}
      onSubmit={(e) => {
        e.preventDefault(); // <-- this stops rogue submit
        handleSubmit((data) => onSubmit(data, e))(e);
      }}
    >
      <Grid2
        container
        alignItems="center"
        justifyContent={"space-between"}
        sx={{ width: "100%", margin: "0 auto" }}
        gap={1}
      >
        {/* rendering site languages if any */}
        {payloadData?.siteLanguageList &&
          payloadData?.siteLanguageList?.length > 0 && (
            <Grid2
              size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                mb: 3,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                  justifyContent: "center",
                }}
              >
                {/* Label */}
                <div
                  style={{
                    flex: "0 0 200px",
                    textAlign: "right",
                    wordWrap: "break-word",
                    paddingTop: "8px",
                  }}
                >
                  Language
                </div>
                <div
                  style={{
                    flex: 1,
                    maxWidth: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Select
                    id="language"
                    fullWidth
                    size="small"
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    onChange={(e) => setSelectedLanguage(e.target.value)}
                    value={selectedLanguage || ""}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {payloadData?.siteLanguageList &&
                      payloadData?.siteLanguageList?.map((item, index) => (
                        <MenuItem value={item?.id} key={index}>
                          {item?.name}
                        </MenuItem>
                      ))}
                  </Select>
                </div>
              </div>
            </Grid2>
          )}

        {currentFields?.map((field, index) => (
          <FieldRenderer
            key={index}
            field={field}
            index={index}
            control={control}
            register={register}
            errors={errors}
            componentMap={componentMap}
            currentFields={currentFields}
          />
        ))}
      </Grid2>
      <Grid2
        alignItems={"end"}
        justifyContent="end"
        container
        gap={3}
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          {currentPageIndex > 0 ? (
            <button
              type="button"
              className="create-btn-outlined"
              onClick={() => setCurrentPageIndex((prev) => prev - 1)}
            >
              Back
            </button>
          ) : (
            <button
              type="button"
              className="create-btn-outlined"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                navigate("/subject");
              }}
            >
              Cancel
            </button>
          )}
        </Grid2>
        <Grid2 item md={6}>
          {currentPageIndex < pages.length - 1 ? (
            <button
              type="button"
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();

                const isValid = await trigger(); // only validate current page
                if (isValid) {
                  setCurrentPageIndex((prev) => prev + 1);
                }
              }}
              className="create-btn"
            >
              Next
            </button>
          ) : (
            <button type="submit" className="create-btn">
              Save
            </button>
          )}
        </Grid2>
      </Grid2>
    </Box>
  );
};
